import "./CaregiverServicePages.module.css";
import Header from "@/reusable_sections/Header";
import MainHero from "./sections/MainHero";
import ServiceCards from "./sections/ServiceCards";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function CaregiverServicePagesPage() {
  return <div>
      <Header />
      <MainHero />
      <ServiceCards />
      <CallToAction />
      <Footer />
    </div>;
}